import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EvaluationDataComponent } from './evaluation-data/evaluation-data.component';
import { AuthGuard } from 'src/app/shared/services';
import { EvaluationHistoryComponent } from './evaluation-history/evaluation-history.component';
import { RequirementEvaluationComponent } from './requirement-evaluation/requirement-evaluation.component';

export const routes: Routes = [
  { path: ':module_id/version/:version_id', component: EvaluationDataComponent, canActivate:[AuthGuard] },

  { path: ':module_id/version/:version_id/chapter/:chapter_id',

  component: EvaluationDataComponent, canActivate:[AuthGuard] },

  { path: ':module_id/version/:version_id/chapter/:chapter_id/index/:index_id',
  component: EvaluationDataComponent, canActivate:[AuthGuard] },

  { path: ':module_id/version/:version_id/chapter/:chapter_id/index/:index_id/item/:item_id',
  component: RequirementEvaluationComponent, canActivate:[AuthGuard] },


  { path: 'history/:module_id/version/:version_id', component: EvaluationHistoryComponent, canActivate:[AuthGuard] },
  
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EvaluationsRoutingModule { }
